import { createContext } from "react";
import { User } from "../../types/User";

export type AuthContextType = {
  user: User | null | false;
  signin: (email: string, password: string, forcarLogin?: boolean) => Promise<boolean | string | object>;
  verificar2FA: (desafio: string, codigo: string) => Promise<string>;
  signout: () => void;
  validateToken: () => Promise<boolean>;
  permissoesUsuario: number[];
  customizadas: boolean;
  loading: boolean;
  permissoesPlanos: any;
};

export const AuthContext = createContext<AuthContextType>(null!);
